module.exports = __webpack_public_path__ + "img/engageko_logo.4eb9e37f.png";